module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-tabs', {
    on: {
      "tab-click": function($event) {
        return _vm.activeNames(_vm.activeName)
      }
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "客服聊天",
      "name": "first"
    }
  }, [_c('div', {
    staticStyle: {
      "min-width": "1290px",
      "height": "750px",
      "overflow-x": "scroll",
      "background-color": "#f1f2f7"
    }
  }, [(_vm.used_list && _vm.used_list.length > 0) ? _c('div', {
    staticClass: "used_list"
  }, [(_vm.used_list && _vm.used_list.length > 0) ? _c('ul', _vm._l((_vm.used_list), function(item, index) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.add_message_value(item.value)
        }
      }
    }, [_vm._v("\n          " + _vm._s(index + 1 + '、' + item.value) + "\n        ")])
  }), 0) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "chat_dig"
  }, [(_vm.content_room && _vm.content_room.room_id) ? _c('div', {
    staticClass: "kefu_jilu"
  }, [_c('div', {
    staticClass: "chat_window"
  }, [_c('div', {
    staticClass: "top_menu"
  }, [_c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "button close"
  }), _vm._v(" "), _c('div', {
    staticClass: "button minimize"
  }), _vm._v(" "), _c('div', {
    staticClass: "button maximize"
  })]), _vm._v(" "), _c('div', {
    staticClass: "title",
    style: ((_vm.content_room.is_online == 1 ? 'color:#0c0' : ''))
  }, [_vm._v(_vm._s(_vm.content_room.user_name))]), _vm._v(" "), _c('div', {
    staticClass: "buttons_right"
  }, [_c('i', {
    staticClass: "el-icon-delete",
    attrs: {
      "title": "消息太多，清空聊天框"
    },
    on: {
      "click": function($event) {
        return _vm.clean_content()
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-document",
    attrs: {
      "title": "聊天记录"
    },
    on: {
      "click": function($event) {
        return _vm.open_histroy()
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-error",
    staticStyle: {
      "color": "#f00"
    },
    attrs: {
      "title": "关闭聊天"
    },
    on: {
      "click": function($event) {
        return _vm.close_content()
      }
    }
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "messages",
    attrs: {
      "id": "messages"
    }
  }, _vm._l((_vm.content_room.content_list), function(item, index) {
    return _c('li', {
      class: 'message ' + (item.type == 2 ? 'right' : 'left') + ' appeared'
    }, [_c('div', {
      staticClass: "avatar"
    }, [_c('img', {
      staticStyle: {
        "width": "100%",
        "height": "100%"
      },
      attrs: {
        "src": item.type == 2 ? _vm.logo2 : _vm.logo1,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "text_wrapper",
      on: {
        "contextmenu": function($event) {
          $event.preventDefault();
          return _vm.rightClick($event, item, index)
        }
      }
    }, [(item.recall != 1) ? _c('div', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.content))]) : _vm._e(), _vm._v(" "), (item.recall == 1) ? _c('div', {
      staticClass: "text",
      staticStyle: {
        "color": "#f00",
        "font-size": "14px",
        "text-align": "center"
      }
    }, [(item.type == 2) ? _c('span', [_vm._v("本消息已撤回，可"), _c('el-button', {
      staticClass: "m-l-10",
      attrs: {
        "size": "text"
      },
      on: {
        "click": function($event) {
          return _vm.set_contents(item.content)
        }
      }
    }, [_vm._v("重新编辑")])], 1) : _vm._e(), _vm._v(" "), (item.type == 1) ? _c('span', [_vm._v("对方撤回了一条消息")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "time"
    }, [_vm._v(_vm._s(item.create_time))])])
  }), 0), _vm._v(" "), _vm._l((_vm.room_list), function(item) {
    return (item.id == _vm.content_room_id) ? _c('div', {
      staticClass: "bottom_wrapper clearfix"
    }, [_c('div', {
      staticClass: "message_input_wrapper"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.content),
        expression: "item.content"
      }],
      staticClass: "message_input",
      attrs: {
        "placeholder": "在此处输入您的消息"
      },
      domProps: {
        "value": (item.content)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "content", $event.target.value)
        }
      }
    }), _vm._v(" "), (item.content) ? _c('i', {
      staticClass: "el-icon-circle-close",
      attrs: {
        "title": "清空"
      },
      on: {
        "click": function($event) {
          item.content = ''
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "send_message",
      on: {
        "click": function($event) {
          return _vm.send_message(item)
        }
      }
    }, [_c('div', {
      staticClass: "icon"
    }), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_vm._v("发送")])])]) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "message_template"
  }, [_c('li', {
    staticClass: "message"
  }, [_c('div', {
    staticClass: "avatar"
  }), _vm._v(" "), _c('div', {
    staticClass: "text_wrapper"
  }, [_c('div', {
    staticClass: "text"
  })])])])]) : _vm._e(), _vm._v(" "), (!_vm.content_room || !_vm.content_room.room_id) ? _c('div', {
    staticClass: "kefu_none"
  }, [_vm._v("\n      请在用户列表选择要联系的用户，或者等待用户主动联系你（勿离开此页面）\n    ")]) : _vm._e()]), _vm._v(" "), (_vm.content_room && _vm.content_room.room_id) ? _c('div', {
    staticClass: "room_list"
  }, [(_vm.room_list && _vm.room_list.length > 0) ? _c('ul', _vm._l((_vm.room_list), function(item) {
    return _c('li', {
      class: (item.id == _vm.content_room_id) ? 'room_active' : '',
      on: {
        "click": function($event) {
          return _vm.read_content(item)
        }
      }
    }, [_c('img', {
      staticClass: "head",
      attrs: {
        "src": _vm.logo1,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "user_name",
      style: ((item.is_online == 1 ? 'color:#0c0' : ''))
    }, [_vm._v(_vm._s(item.user_name))]), _vm._v(" "), _c('div', {
      staticClass: "last_time"
    }, [_vm._v(_vm._s(_vm.time_chaju(item.last_time)))]), _vm._v(" "), _c('div', {
      staticClass: "last_content"
    }, [(!item.content) ? _c('span', [_vm._v(_vm._s(item.last_content))]) : _vm._e(), (item.content) ? _c('span', [(item.id != _vm.content_room_id) ? _c('span', {
      staticStyle: {
        "color": "#f00"
      }
    }, [_vm._v("草稿：" + _vm._s(item.content))]) : _vm._e(), (item.id == _vm.content_room_id) ? _c('span', [_vm._v(_vm._s(item.last_content))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (item.kefu_no_read > 0) ? _c('el-badge', {
      staticClass: "item",
      attrs: {
        "value": (item.kefu_no_read > 99) ? '99+' : item.kefu_no_read
      }
    }, [_c('div', {
      staticClass: "no_read"
    })]) : _vm._e()], 1)
  }), 0) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "用户列表",
      "name": "second"
    }
  }, [_c('div', {
    staticClass: "user_list"
  }, [_c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-input', {
    staticClass: "w-300",
    attrs: {
      "placeholder": "请输入账号/真实姓名",
      "clearable": ""
    },
    model: {
      value: (_vm.keywords),
      callback: function($$v) {
        _vm.keywords = $$v
      },
      expression: "keywords"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        return _vm.search()
      }
    },
    slot: "append"
  })], 1), _vm._v(" "), _c('el-checkbox', {
    on: {
      "change": function($event) {
        return _vm.search()
      }
    },
    model: {
      value: (_vm.new_service),
      callback: function($$v) {
        _vm.new_service = $$v
      },
      expression: "new_service"
    }
  }, [_vm._v("最近在聊")])], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "height": _vm.setHeight.pane_height,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user_head",
      "label": "头像"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popover', {
          attrs: {
            "placement": "right-end",
            "width": "400",
            "trigger": "click"
          }
        }, [_c('img', {
          attrs: {
            "src": scope.row.user_head ? scope.row.user_head : _vm.logo2,
            "width": "100%"
          }
        }), _vm._v(" "), _c('img', {
          attrs: {
            "slot": "reference",
            "src": scope.row.user_head ? scope.row.user_head : _vm.logo2,
            "width": "50",
            "height": "50"
          },
          slot: "reference"
        })])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "账号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user_name",
      "label": "真实姓名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "realname",
      "label": "最近聊天客服"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "last_time",
      "label": "最近聊天时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_c('span', [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "success"
          },
          on: {
            "click": function($event) {
              return _vm.start_service(scope.row.id)
            }
          }
        }, [_vm._v("发起聊天")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.send_notice_user(scope.row)
            }
          }
        }, [_vm._v("发送通知")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.open_notice_user(scope.row)
            }
          }
        }, [_vm._v("通知记录")])], 1)])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pos-rel p-t-20"
  }, [_c('div', {
    staticClass: "block fr"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, prev, pager, next",
      "page-size": _vm.limit,
      "current-page": _vm.currentPage,
      "total": _vm.dataCount
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "全体通知",
      "name": "third"
    }
  }, [_c('div', {
    staticClass: "fr"
  }, [_c('el-button', {
    attrs: {
      "type": "success",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.open_notice_dig()
      }
    }
  }, [_vm._v("发送全体通知")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-input', {
    staticClass: "w-300",
    attrs: {
      "placeholder": "请输入标题/内容",
      "clearable": ""
    },
    model: {
      value: (_vm.keywords3),
      callback: function($$v) {
        _vm.keywords3 = $$v
      },
      expression: "keywords3"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        return _vm.search3()
      }
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData3,
      "height": _vm.setHeight.page_height - 80,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "标题"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "内容"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.value)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "发送时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [(scope.row.status == 1) ? _c('span', {
          staticStyle: {
            "color": "#0c0"
          }
        }, [_vm._v("正常")]) : (scope.row.status == 0) ? _c('span', {
          staticStyle: {
            "color": "#bb0"
          }
        }, [_vm._v(_vm._s(_vm._f("status")(scope.row.status)))]) : (scope.row.status == -1) ? _c('span', {
          staticStyle: {
            "color": "#d00"
          }
        }, [_vm._v(_vm._s(_vm._f("status")(scope.row.status)))]) : _vm._e()])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_c('span', [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.confirmDelete(scope.row)
            }
          }
        }, [_vm._v("删除")])], 1)])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pos-rel p-t-20"
  }, [_c('btnGroup', {
    attrs: {
      "selectedData": _vm.multipleSelection,
      "type": 'used'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "block pages"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.limit3,
      "current-page": _vm.currentPage3,
      "total": _vm.dataCount3
    },
    on: {
      "current-change": _vm.handleCurrentChange3
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "chat_dig_his",
    attrs: {
      "title": _vm.content_room.user_name + '的聊天记录',
      "visible": _vm.histroy_open,
      "custom-class": "w-800",
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.histroy_open = $event
      }
    }
  }, [(_vm.message_list && _vm.message_list.length > 0) ? _c('ul', {
    staticClass: "his_messages",
    attrs: {
      "id": "his_messages"
    }
  }, _vm._l((_vm.message_list), function(item) {
    return _c('li', {
      class: 'message ' + (item.type == 2 ? 'right' : 'left') + ' appeared'
    }, [_c('div', {
      staticClass: "avatar"
    }, [_c('img', {
      staticStyle: {
        "width": "100%",
        "height": "100%"
      },
      attrs: {
        "src": item.type == 1 ? _vm.logo1 : _vm.logo2,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "text_wrapper"
    }, [_c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })])])
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.message_list || _vm.message_list.length == 0) ? _c('div', {
    staticClass: "no_his_message"
  }, [_c('p', {
    staticClass: "error_status"
  }, [_vm._v("没有聊天记录")])]) : _vm._e()]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.notice_user_name + '的通知记录',
      "visible": _vm.user_notice_open,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.user_notice_open = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-input', {
    staticClass: "w-300",
    attrs: {
      "placeholder": "请输入通知标题/内容",
      "clearable": ""
    },
    model: {
      value: (_vm.keywords2_1),
      callback: function($$v) {
        _vm.keywords2_1 = $$v
      },
      expression: "keywords2_1"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        return _vm.search2_1()
      }
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData2_1,
      "height": 600,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "realname",
      "label": "发送人",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "标题",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "内容"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(scope.row.value)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "width": "170",
      "label": "通知时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [(scope.row.is_read == 1) ? _c('span', {
          staticStyle: {
            "color": "#0c0"
          }
        }, [_vm._v("已读")]) : _c('span', {
          staticStyle: {
            "color": "#d00"
          }
        }, [_vm._v("未读")])])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pos-rel p-t-20"
  }, [_c('div', {
    staticClass: "block pages"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.limit2_1,
      "current-page": _vm.currentPage2_1,
      "total": _vm.dataCount2_1
    },
    on: {
      "current-change": _vm.handleCurrentChange2_1
    }
  })], 1)])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编写通知内容",
      "visible": _vm.notice_open,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.notice_open = $event
      }
    }
  }, [_c('el-form', {
    ref: "notice_form",
    attrs: {
      "model": _vm.notice_form,
      "label-width": "20%",
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "接收人",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('span', [_vm._v(_vm._s((_vm.notice_form.user_id == 0) ? '全体用户' : _vm.notice_name))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "标题",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.notice_form.name),
      callback: function($$v) {
        _vm.$set(_vm.notice_form, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "notice_form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "内容",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.notice_form.value),
      callback: function($$v) {
        _vm.$set(_vm.notice_form, "value", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "notice_form.value"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否紧急",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.notice_form.is_urgent),
      callback: function($$v) {
        _vm.$set(_vm.notice_form, "is_urgent", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "notice_form.is_urgent"
    }
  }, [_vm._v("紧急")]), _c('span', {
    staticClass: "error_status m-l-50"
  }, [_vm._v(" 勾选紧急后，通知将会拉起用户的通知弹窗")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.notice_open = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.send_notice()
      }
    }
  }, [_vm._v("发 送")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.rightMenu),
      expression: "rightMenu"
    }],
    ref: "rightMenu",
    staticClass: "right-menu",
    staticStyle: {
      "z-index": "999999999999999"
    }
  }, [(_vm.activeMenuItem.content && _vm.activeMenuItem.recall != 1) ? _c('div', {
    class: ['menu-item'],
    on: {
      "click": function($event) {
        return _vm.copy_text(_vm.activeMenuItem.content, '消息')
      }
    }
  }, [_c('span', {
    staticClass: "menu-item_licon iconfont icon-guanbiqita"
  }), _vm._v("复制消息\n    ")]) : _vm._e(), _vm._v(" "), (_vm.time_check() == true) ? _c('div', {
    class: ['menu-item'],
    on: {
      "click": function($event) {
        return _vm.cehui_message($event)
      }
    }
  }, [_c('span', {
    staticClass: "menu-item_licon iconfont icon-guanbiqita"
  }), _vm._v("撤回消息\n    ")]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3ac7bb2a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Appistrative/company/service/list.vue
// module id = 1831
// module chunks = 2